import { Injectable, inject } from '@angular/core'
import { ApiClientFactory, CacheableApiClient } from '@ftr/api-shared'
import { GetCourtroomsQuery, Location } from '@ftr/contracts/api/location'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult } from '@ftr/foundation'
import { classToPlain } from '@ftr/serialization'
import { ChildLocation } from '../types'

@Injectable({
  providedIn: 'root',
})
export class CourtroomService extends CacheableApiClient<ChildLocation> {
  constructor() {
    const apiClientFactory = inject(ApiClientFactory)
    super(apiClientFactory, 'location')
  }

  protected retrieveAll(courtSystemId: Uuid, courtroomIds: Uuid[]): ApiResult<ChildLocation[]> {
    return this.apiClient.post({
      path: '/courtrooms',
      body: classToPlain<GetCourtroomsQuery>({
        courtSystemId,
        courtroomIds,
      }),
      responseBodyType: Location,
    })
  }

  applyLocationMutation(courtSystemId: Uuid, location: Location): void {
    const timedCache = this.cache.get(courtSystemId)
    const cached = timedCache?.get(location.id)
    if (!cached || !timedCache) {
      return
    }
    this.cache.set(courtSystemId, timedCache.addAll({ ...cached, videoStatus: location.videoStatus }))
  }
}
